import Vue from "vue";
import router from "@/router";
import conf from "./brands";
import {
  obtenerTrackingCode,
  obtenerDeviceId,
  obtenerDeviceIdTimestamp
} from "@/utils";
import store from "@/store";
import {
  ON_TCODE,
  DO_GET_DEVICEID,
  DO_GET_DEVICEIDTIMESTAMP
} from "@/config/constants/action-types";

const values = {};

const normalizeComponentPath = component =>
  component.endsWith(".vue") ? component.slice(0, -4) : component;

export const resolveRouteComponent = component => {
  const normalizedPath = normalizeComponentPath(component);

  if (normalizedPath.startsWith("components/views/")) {
    const viewPath = normalizedPath.replace("components/views/", "");
    return () => import(`@/components/views/${viewPath}.vue`);
  }

  if (normalizedPath.startsWith("features/mortgage/")) {
    const featurePath = normalizedPath.replace("features/mortgage/", "");
    return () => import(`@/features/mortgage/${featurePath}.vue`);
  }

  return () =>
    Promise.reject(new Error(`Ruta de componente no soportada: ${component}`));
};

const config = {
  install(Vue) {
    /**
     * Setear deviceId
     */
    try {
      store.dispatch(DO_GET_DEVICEID, obtenerDeviceId());
    } catch (e) {
      Vue.$log.error("Error obteniendo el deviceId: " + e);
    }

    /**
     * Setear deviceIdTimestamp
     */
    try {
      store.dispatch(DO_GET_DEVICEIDTIMESTAMP, obtenerDeviceIdTimestamp());
    } catch (e) {
      Vue.$log.error("Error obteniendo el timeStamp: " + e);
    }
    /**
     *Voy a buscar el tracking code y lo guardo en el store
     */
    try {
      store.dispatch(ON_TCODE, obtenerTrackingCode());
      Vue.$log.info(obtenerTrackingCode());
    } catch (e) {
      Vue.$log.info("Error obteniendo tcode: " + e);
    }
    Vue.mixin({
      mounted() {},
      computed: {
        config() {
          return this.$config.get();
        }
      }
    });
  },
  start(_callback) {
    // Voy a buscar la config del Branding
    // Guardo la config en la instancia local
    values.json = conf;
    // Armo los 'routes' usando los pasos
    let routes = [];
    for (let key in conf.pasos) {
      if (Object.prototype.hasOwnProperty.call(conf.pasos, key)) {
        let route = conf.pasos[key];

        // Armo un objeto para guardar el 'route'
        let routeSave = {};
        routeSave.path = route.path;

        // Como 'route.name', el key en la config
        routeSave.name = key;
        routeSave.component = resolveRouteComponent(route.component);
        routes.push(routeSave);
      }
    }

    routes.forEach(route => router.addRoute(route));
    _callback();
  },
  get() {
    return values.json;
  },
  getPasoProperties(paso) {
    return this.get().pasos[paso];
  }
};

Vue.prototype.$config = config;

export default config;
